var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "#D9D9D9",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.55 10.3125H17.1V7.14551C17.1 6.77344 16.9566 6.41602 16.7034 6.15234L13.8938 3.22559C13.6406 2.96191 13.2975 2.8125 12.9403 2.8125H11.7V1.40625C11.7 0.629883 11.0953 0 10.35 0H1.35C0.604688 0 0 0.629883 0 1.40625V10.7812C0 11.5576 0.604688 12.1875 1.35 12.1875H1.8C1.8 13.7402 3.00938 15 4.5 15C5.99062 15 7.2 13.7402 7.2 12.1875H10.8C10.8 13.7402 12.0094 15 13.5 15C14.9906 15 16.2 13.7402 16.2 12.1875H17.55C17.7975 12.1875 18 11.9766 18 11.7188V10.7812C18 10.5234 17.7975 10.3125 17.55 10.3125ZM4.5 13.5938C3.75469 13.5938 3.15 12.9639 3.15 12.1875C3.15 11.4111 3.75469 10.7812 4.5 10.7812C5.24531 10.7812 5.85 11.4111 5.85 12.1875C5.85 12.9639 5.24531 13.5938 4.5 13.5938ZM13.5 13.5938C12.7547 13.5938 12.15 12.9639 12.15 12.1875C12.15 11.4111 12.7547 10.7812 13.5 10.7812C14.2453 10.7812 14.85 11.4111 14.85 12.1875C14.85 12.9639 14.2453 13.5938 13.5 13.5938ZM15.75 7.5H11.7V4.21875H12.9403L15.75 7.14551V7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.2c843ef810d8ffb021a962ebd99ac03d.svg";
export { ForwardRef as ReactComponent };